<template>
  <div class="QuestionnariesContainer">
    <div class="QuestionnariesContainer__logo-container">
      <DasaLogoSvg />
      <p>Questionário</p>
    </div>
    <div class="QuestionnariesContainer__iframe-wrapper">
      <iframe
        v-if="!doneWithQuestionnaires"
        :src="questionnariesLink.link"
        :title="questionnariesLink.name"
        id="surveyIframe"
      />

      <div v-else class="end-message">
        Obrigado por responder nosso questionário, você será redirecionado novamente a nossa página
        final.
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'questionnaries',
  data() {
    return {
      questionnariesLink: null,
      stepsDone: [],
      currentStepIndex: -1,
      currentStep: {},
      doneWithQuestionnaires: false,
    };
  },
  methods: {
    ...mapActions(['global/updateFlowSteps']),
  },
  created() {
    if (this.$route.params.surveys) {
      this.questionnariesLink = this.$route.params.surveys;
    }
  },
};
</script>

<style lang="scss" scoped>
.QuestionnariesContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__logo-container {
    height: 36px;
    margin-right: 16.25px;
    margin-bottom: 16px;
    margin-top: 16px;

    svg {
      height: 100%;
    }
  }

  &__iframe-wrapper {
    margin-top: 24px;
    width: 100%;
    background-color: white;
    border-radius: 16px;
    flex: 1;
    overflow: hidden;

    iframe {
      width: 100%;
      border: none;
      flex: 1;
      height: 100%;
    }
  }

  .end-message {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    font-weight: 500;
    font-size: 18px;
    color: var(--color-secondary-lighten-1);
    line-height: 21px;
  }
}
</style>

<style lang="scss">
.questionnaries {
  > .container {
    padding: 16px 8px;
    background-color: #ecedf2;
  }
}
</style>
